import React from 'react';
import propTypes from 'prop-types';

export const RightLongIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 476.213 476.213"
      enableBackground="new 0 0 476.213 476.213;"
      // style="enable-background:new 0 0 476.213 476.213;"
      xmlSpace="preserve"
    >
      <polygon points="476.213,238.105 400,161.893 400,223.106 0,223.106 0,253.106 400,253.106 400,314.32 " />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
RightLongIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
RightLongIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
